export default __webpack_public_path__ + "static/media/Group 44.aa7069a5.svg";